if (!customElements.get('pro-team-slider')) {
  class ProTeamSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const swiper = new Swiper(this.querySelector('[data-slider]'), {
        loop: true,
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
      });
    }
  }
  customElements.define('pro-team-slider', ProTeamSlider);
}
